import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '~/components/tooltip/Tooltip';

import * as S from './WithNAFallback.styles';

export interface WithNAFallbackProps {
  value: React.ReactNode;
  check?: boolean;
  useFallbackDash?: boolean;
  tooltip?: string;
}

export const WithNAFallback = ({
  value,
  check = true,
  useFallbackDash = false,
  tooltip,
}: WithNAFallbackProps) => {
  const { t } = useTranslation('common');

  if (check && value) {
    return value;
  }

  return (
    <Tooltip label={tooltip} disabled={!tooltip}>
      <S.Container>
        <S.Text data-testid="table-cell-empty-value" $useDash={useFallbackDash}>
          {useFallbackDash ? '-' : t('common:table.na')}
        </S.Text>
      </S.Container>
    </Tooltip>
  );
};

WithNAFallback.Styled = S;
